// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_7-1";
export var movingGradient = "_7-4";
export var movingGradientBlock = "_7-2";
export var skeleton = "_7-0";
export var skeletonText = "_7-3";